import { userUploadWatcherSaga } from './upload.saga'
import { searchUserListWatcherSaga } from './list.saga'
import { decodeJwtWatcherSaga } from './decode-jwt.saga'

export const sagas = [
  userUploadWatcherSaga(),
  searchUserListWatcherSaga(),
  decodeJwtWatcherSaga(),
]
export default sagas
